import * as React from "react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import * as Hygeian from "../../../constants/hygeian";
import { get } from "../../../redux/actions/checklistTemplateActions";
import {
  get as getGroup,
  insert as insertGroup,
} from "../../../redux/actions/groupActions";
import { connect } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import Groups from "../../group/groups";

const options = {
  labels: {
    confirmable: "Confirm",
    cancellable: "Cancel",
  },
};

class MultiSelectCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValue: null,
      showGroupGrid: false,
    };
  }
  handleChange = (e) => {
    if (this.props.onChange) {
      this.props.onChange({
        dataIndex: 0,
        dataItem: this.props.dataItem,
        field: this.props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    }
  };

  onFilterChange = (event) => {
    //console.log("filterChange", event.filter.value);
    this.setState({ filterValue: event.filter.value });
  };

  submitNewGroup = () => {
    if (this.state.filterValue) {
      if (
        // eslint-disable-next-line no-restricted-globals
        confirm(
          "Confirm New Group Creation - '" + this.state.filterValue + "'"
        ) == true
      ) {
        let group = {
          groupTypeName: "ChecklistTemplate",
          name: this.state.filterValue,
          enterpriseId: this.props.dataItem.enterprise.entid1,
        };
        console.log("You pressed OK!", group);
        this.props.insertGroup(group);
      } else {
      }
    } else {
      if (
        // eslint-disable-next-line no-restricted-globals
        alert("New Group Must Be Entered") == true
      ) {
        console.log("You pressed OK!");
      } else {
        console.log("You canceled!");
      }
    }
  };

  toggleGroupGrid = () => {
    this.setState({ showGroupGrid: !this.state.showGroupGrid });
    //console.log("toggleGroupGrid", this.state.showGroupGrid);
  };

  render() {
    const { dataItem } = this.props;
    if (!dataItem)
      return null;
    const field = this.props.field || "";
    let dataValue = []; // = dataItem[field] === null ? "" : dataItem[field];
    let groupsString = "";
    try {
      dataValue = !dataItem?.[field] ? [] : dataItem[field];
      //console.log("dataValue", dataValue);
      dataValue.map((d) => (groupsString = groupsString + ", " + d.name));
    } catch (e) {
      //console.log(e);
    }
    let multiSelect;
    if (this.props.disabled) {
      multiSelect = (
        <div>
          <span className={"k-widget k-multiselect one"} disabled={true}>
            <div className="k-multiselect-wrap k-floatwrap">
              Select a Checklist
              {/*<input value={"select a Checklist"} />*/}
            </div>
          </span>
        </div>
      );
    } else {
    }
    multiSelect = (
      <MultiSelect
        className={"one"}
        style={{
          width: "401px",
        }}
        filterable={true}
        onFilterChange={this.onFilterChange}
        onChange={this.handleChange}
        value={this.props.dataItem?.group}
        data={this.props.group}
        dataItemKey={"id"}
        textField="name"
        disabled={this.props.disabled}
        placeholder={
          this.props.disabled
            ? this.props.validationMessage
            : "Please select Groups"
        }
      />
    );

    let groupGrid = (
      <Groups
        data={this.props.data}
        toggleGroupGrid={this.toggleGroupGrid}
        addInline={true}
        editInline={true}
      />
    );

    return (
      <td>
        <div>
          {this.props.inEdit || this.props.filter ? (
            <div>
              <label>Group</label>
              <div className={"container"}>
                {!this.props.filter && this.state.showGroupGrid
                  ? groupGrid
                  : multiSelect}
                {!this.props.filter ? (
                  <span
                    className={"k-button two"}
                    //onClick={this.submitNewGroup}
                    onClick={this.toggleGroupGrid}
                  >
                    {!this.state.showGroupGrid
                      ? "Manage Groups"
                      : "Hide Managed Groups"}
                  </span>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            //dataValue?.map((d) => d.toString())

            groupsString?.substring(2)
          )}
        </div>
      </td>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    claims: state.authReducer.user.profile.claims,
    group: state.groupReducer.group,
    isGodMode:
      state.authReducer.user.profile.scopeid == Hygeian.ScopeId &&
      state.authReducer.user.profile.entid == Hygeian.EntId,
  };
};

const mapDispatchToProps = {
  get,
  getGroup,
  insertGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectCell);
